<template>
    <v-container>
        <v-card>
            <v-container>
                <v-row no-gutters>
                    <v-col cols="2" align="right" class="mr-3">
                        <div class="mt-2 pr-5">
                            <b>Text</b>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <v-textarea
                            ref="textField"
                            v-model="textFieldValue"
                            @click="setCaretPosition"
                            @keypress="typeKeyboardChar($event)"
                            @keydown="backSpace($event)"
                            @keyup="arrowPaste($event)"
                            counter
                            outlined
                            dense 
                            rows="3" 
                       ></v-textarea>
                    </v-col>
                    <v-col>
                        <v-btn
                            class="mx-5"
                            type="submit"
                            color="#b297ff"
                            width="90"
                            @click="clearTextField"
                            >Clear</v-btn
                        >
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2"></v-col>
                        <span>
                            <v-btn v-for="(item, i) in arrSpecialNotes1" :key="i" @click="appendSpecialNote1(i)" width="10px" height="25px" style="text-transform:none;">
                                {{item}}
                            </v-btn>
                        </span>
                    </v-row>

                    <v-row>
                        <v-col cols="2"></v-col>
                        <span>
                            <v-btn v-for="(item, i) in arrSpecialNotes2" :key="i" @click="appendSpecialNote2(i)" width="10px" height="25px" style="text-transform:none;">
                                {{item}}
                            </v-btn>
                        </span>
                    </v-row>

                    <v-row>
                        <v-col cols="2"></v-col>
                
                        <span>
                            <v-btn v-for="(item, i) in arrSpecialNotes3" :key="i" @click="appendSpecialNote3(i)" width="10px" height="25px" style="text-transform:none;">
                                {{item}}
                            </v-btn>
                        </span>
                    </v-row>

                    <v-row  >
                        <v-col cols="2"></v-col>
                        <span >
                            <v-btn v-for="(item, i) in arrSpecialNotes4" :key="i" @click="appendSpecialNote4(i)" width="10px" height="25px" style="text-transform:none;">
                                {{item}}
                            </v-btn>
                        </span>
                    </v-row>
        
                    <v-row>
                        <v-col cols="2"></v-col>
                        <span>
                            <v-btn v-for="(item, i) in arrSpecialNotes5" :key="i" @click="appendSpecialNote5(i)" width="10px" height="25px" style="text-transform:none;">
                                {{item}}
                            </v-btn>
                        </span>
                    </v-row>
                    <v-divider></v-divider>
                    
                    <v-row>
                        <v-col cols="10">
                            <v-card-actions style="justify-content:center;">
                                <v-btn class="mx-5" text @click="cancelEditText">cancel</v-btn> <!--to ask what to do in case of cancel--> 
                                <v-btn
                                    class="mx-5"
                                    type="submit"
                                    color="#b297ff"
                                    width="90"
                                    @click="saveEditedText"
                                    >Submit</v-btn
                                >
                            </v-card-actions>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
    </v-container>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            setTimeout(() => {
                if (!vm.$store.state.auth.adminUser._id)
                    vm.$router.push("/");
            }, 0);
        });
    },
    name: "EditText",
    props:['editedText'],
    data() {
        return {
                    arrSpecialNotes1:[
                        "Ṡ","Ṙ","Ġ","Ṁ","Ṗ","Ḋ","Ṅ",
                    ],
                    arrSpecialNotes2:[
                        "Ṣ","Ṛ","G̣","Ṃ","P̣","Ḍ","Ṇ"
                    ],
                    arrSpecialNotes3:[
                        "ṡ","ṙ","ġ","ṁ","ṗ","ḋ","ṅ"
                    ],
                    arrSpecialNotes4:[
                        "ṣ","ṛ","g̣","ṃ","p̣","ḍ","ṇ"
                    ], 
                    arrSpecialNotes5:[
                        "M̍","Ṃ̍", "M̍̇", "Ṉ", "ṉ"
                    ],

                  
                    
                    text:this.editedText,
                    textFieldValue:this.editedText,
                    editTextDialog:false,
                    cursorPos:this.editedText.length,
                    cursorStart:undefined,
                    cursorEnd:undefined,
                    // textField:undefined
                    //textField:this.$refs.textField.$refs.input,
                    //editedText:''
                    //text:this.editedText,
                }
            },

    methods:{

        appendSpecialNote1(itemIndex){
            const specialcharacter = this.arrSpecialNotes1[itemIndex];
            let specialcharacterLength = this.arrSpecialNotes1[itemIndex].length
            if (!specialcharacterLength)
                return;
            //console.log('Insert Char', specialcharacter);
            var textField=this.$refs.textField.$refs.input;  
            let sentence = this.textFieldValue;
           if(sentence===undefined||sentence===null)
            {    
                //console.log("sentence is undefined");
                sentence = '';
            }    
            const len = sentence.length;
            //console.log("cursor pos", this.cursorPos);
            if(this.cursorPos === undefined) {
                //console.log("cursorpos is undefined");
                this.cursorPos=0;
           }
            //console.log('text field', textField, 'value', sentence, 'len',len, 'cursorpos', this.cursorPos); 
            const before = sentence.substr(0,this.cursorPos);
            const after = sentence.substr(this.cursorPos, len);  
            this.textFieldValue = before + specialcharacter + after;
            //console.log('textfield before +spl char+  after', textField.value);
            let newPos=this.cursorPos+specialcharacterLength;
            //console.log('selec start 1',textField.selectionStart);
            this.cursorPos=newPos;
            textField.focus();
            this.$nextTick(() => {
                textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            //console.log('initial substring',before,'the character to be added',specialcharacter,'later substring', after);     
       },

        appendSpecialNote2(itemIndex){
            const specialcharacter = this.arrSpecialNotes2[itemIndex];
            let specialcharacterLength = this.arrSpecialNotes2[itemIndex].length
            if (!specialcharacterLength)
                return;
            //console.log('Insert Char', specialcharacter);
            var textField=this.$refs.textField.$refs.input;  
            let sentence= this.textFieldValue;
            if(sentence===undefined||sentence===null)
            {    
                //console.log("sentence is undefined");
                sentence = '';
            }
            const len = sentence.length;
            //console.log("cursor pos", this.cursorPos);
            if(this.cursorPos === undefined) {
                //console.log("cursorpos is undefined");
                this.cursorPos=0;
            }
            //console.log('text field', textField, 'value', sentence, 'len',len, 'cursorpos', this.cursorPos);
            const before = sentence.substr(0,this.cursorPos);
            const after = sentence.substr(this.cursorPos, len);    
            this.textFieldValue = before + specialcharacter + after;
            //console.log('textfield before +spl char+  after', textField.value);
            let newPos=this.cursorPos+specialcharacterLength;
            this.cursorPos=newPos;
            textField.focus();
            this.$nextTick(() => {
                textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            //console.log('initial substring',before,'the character to be added',specialcharacter,'later substring', after);
                 
       },

       appendSpecialNote3(itemIndex){
            const specialcharacter = this.arrSpecialNotes3[itemIndex];
            let specialcharacterLength = this.arrSpecialNotes3[itemIndex].length
            if (!specialcharacterLength)
                return;
            //console.log('Insert Char', specialcharacter);
            var textField=this.$refs.textField.$refs.input;  
            let sentence = this.textFieldValue;
            if(sentence===undefined||sentence===null)
            {    
                //console.log("sentence is undefined");
                sentence = '';
            }
            const len = sentence.length;
            //console.log("cursor pos", this.cursorPos)
            if(this.cursorPos === undefined) {
                //console.log("cursorpos is undefined");
                this.cursorPos=0;
            }
            console.log('text field', textField, 'value', sentence, 'len',len, 'cursorpos', this.cursorPos);
            const before = sentence.substr(0,this.cursorPos);
            const after = sentence.substr(this.cursorPos, len);    
            this.textFieldValue = before + specialcharacter + after;
            //console.log('textfield before +spl char+  after', textField.value);
            let newPos=this.cursorPos+specialcharacterLength;
            //console.log('selec start 1',textField.selectionStart);
            this.cursorPos=newPos;
            textField.focus(); 
            this.$nextTick(() => {
                textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            //console.log('initial substring',before,'the character to be added',specialcharacter,'later substring', after);
       },

         appendSpecialNote4(itemIndex){
            const specialcharacter = this.arrSpecialNotes4[itemIndex];
            let specialcharacterLength = this.arrSpecialNotes4[itemIndex].length
            if (!specialcharacterLength)
                return;
            //console.log('Insert Char', specialcharacter);
            var textField=this.$refs.textField.$refs.input;  
            let sentence = this.textFieldValue;
            if(sentence===undefined||sentence===null)
            {    
                //console.log("sentence is undefined");
                sentence = '';
            }
            const len = sentence.length; 
            //console.log("cursor pos", this.cursorPos)
            if(this.cursorPos === undefined) {
                //console.log("cursorpos is undefined");
                this.cursorPos=0;
            }
            //console.log('text field', textField, 'value', sentence, 'len',len, 'cursorpos', this.cursorPos);
            const before = sentence.substr(0,this.cursorPos);
            const after = sentence.substr(this.cursorPos, len);    
            this.textFieldValue = before + specialcharacter + after;
            //console.log('textfield before +spl char+  after', textField.value);
            let newPos=this.cursorPos+specialcharacterLength;
            console.log('selec start 1',textField.selectionStart);
            this.cursorPos=newPos;
            textField.focus(); 
            this.$nextTick(() => {
                textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            //console.log('initial substring',before,'the character to be added',specialcharacter,'later substring', after);
       },

        appendSpecialNote5(itemIndex){
            const specialcharacter = this.arrSpecialNotes5[itemIndex];
            let specialcharacterLength = this.arrSpecialNotes5[itemIndex].length
            if (!specialcharacterLength)
                return;
            //console.log('Insert Char', specialcharacter);
            var textField=this.$refs.textField.$refs.input;  
            let sentence = this.textFieldValue;
            if(sentence===undefined||sentence===null)
            {    
                //console.log("sentence is undefined");
                sentence = '';
            }
            const len = sentence.length;
            //console.log("cursor pos", this.cursorPos)
            if(this.cursorPos === undefined) {
                //console.log("cursorpos is undefined");
                this.cursorPos=0;
            }
            //console.log('text field', textField, 'value', sentence, 'len',len, 'cursorpos', this.cursorPos);
            const before = sentence.substr(0,this.cursorPos);
            const after = sentence.substr(this.cursorPos, len);    
            this.textFieldValue = before + specialcharacter + after;
            //console.log('textfield before +spl char+  after', textField.value);
            let newPos=this.cursorPos+specialcharacterLength;
            //console.log('selec start 1',textField.selectionStart);
            this.cursorPos=newPos;
            textField.focus(); 
            this.$nextTick(() => {
                textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            //console.log('initial substring',before,'the character to be added',specialcharacter,'later substring', after);
        },

        saveEditedText(){
            var textField=this.$refs.textField.$refs.input;
            var len=this.textFieldValue.length;
            this.cursorPos=len;
            this.$nextTick(() => {
                textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            this.$emit('changeEditedText', this.textFieldValue);
        },

       async cancelEditText(){
            this.textFieldValue=this.editedText;
            //setTimeout(()=>{}, 5000);
            //await new Promise(r => setTimeout(r, 5000));
            //this.setCaretPosition();//
            var textField=this.$refs.textField.$refs.input;//
            var len;
            //var len=this.textFieldValue.length;//
            //if(this.textFieldValue===undefined)
            if(this.textFieldValue===undefined||this.textFieldValue===null)
            {
                this.textFieldValue='';
                this.cursorPos=0;//to remove if causes error
                len=0;
            }
            // console.log('cancel edit text', this.textFieldValue);
            // var len=this.editedText.length;

           else{
                 len=this.editedText.length;
                 console.log('else len', len);
                 this.cursorPos=len;//
           }
        //    var len=this.textFieldValue.length;
        //     this.cursorPos=len;//
             console.log('cancel edit text', this.textFieldValue);//
            //textField.setSelectionRange(len, len);//
            ////      textField.setSelectionRange(this.cursorPos, this.cursorPos);//
            await this.$nextTick(() => {
                console.log('cancel cursor pos', this.cursorPos);
                textField.focus();
               // textField.setSelectionRange(len, len);//this.cursorPos, this.cursorPos);
                textField.setSelectionRange(this.cursorPos, this.cursorPos);
            })
            console.log('length cancel', len, 'pos cancel', textField.selectionStart);
            //await new Promise(r => setTimeout(r, 5000));
            this.$emit('changeEditedText', null);
        }, 

        setCaretPosition(){
            var textField=this.$refs.textField.$refs.input;
            this.cursorStart=textField.selectionStart;
            this.cursorEnd=textField.selectionEnd;
            //console.log('set caret pos', this.cursorStart, this.cursorEnd);
            if(this.cursorStart===this.cursorEnd)
            {
                this.cursorPos=textField.selectionStart;
                this.$nextTick(() => {
                    textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            }
            else{
                this.cursorPos=textField.selectionStart;
            }
       },

        typeKeyboardChar(e)
        {
            e.preventDefault();
            console.log('type keyboard char')
            if(this.textFieldValue===undefined||this.textFieldValue===null)
            {
                this.textFieldValue='';
                this.cursorPos=0;
            }
            let pos=this.cursorPos;
            let char = String.fromCharCode(e.keyCode);
            let sentence=this.textFieldValue
            const len = sentence.length;
            const before = sentence.substr(0,this.cursorPos);
            const after = sentence.substr(this.cursorPos, len);  
            this.textFieldValue = before + char + after;
            pos=pos+char.length;
            this.cursorPos=pos;
            var textField=this.$refs.textField.$refs.input;
            this.$nextTick(() => {
                textField.setSelectionRange(this.cursorPos, this.cursorPos)
                textField.scrollTop = textField.scrollHeight;
            })
            //console.log('type char keyboard 2');
        },

            backSpace(e){
            // var textField=this.$refs.textField.$refs.input;
            let textField=this.$refs.textField.$refs.input;
            let cursorStart=textField.selectionStart;
            let cursorEnd=textField.selectionEnd;
            //console.log('backspace', this.cursorStart, this.cursorEnd);
            if(e.keyCode===8)
            {
                if(cursorStart===cursorEnd)
                {
                    if(!(this.cursorPos===0))
                    {
                        let pos=this.cursorPos;
                        const before=this.textFieldValue.slice(0, pos-1);
                        const after=this.textFieldValue.slice(pos);
                        this.textFieldValue=before+after;
                        this.cursorPos=pos-1;
                        e.preventDefault();
                        this.$nextTick(() => {
                            textField.setSelectionRange(this.cursorPos, this.cursorPos)
                        })
                    }
                    else{
                        console.log("no prev chars");
                        e.preventDefault()
                    }
                }
                else{
                    const before=this.textFieldValue.slice(0, cursorStart);
                    const after=this.textFieldValue.slice(cursorEnd);
                    this.textFieldValue=before+after;
                    this.cursorPos=cursorStart;
                    e.preventDefault();
                    this.$nextTick(() => {
                            textField.setSelectionRange(this.cursorPos, this.cursorPos)
                        })
                }
            
            }
            
       },


       arrowPaste(e){
            var keyCode = e.keyCode ||e.which;
            let textField=this.$refs.textField.$refs.input;
            switch(keyCode)
            {
                case 37:{
                            this.cursorPos=textField.selectionStart;
                            textField.setSelectionRange(this.cursorPos, this.cursorPos)
                            e.preventDefault();
                            break;
                        }
                case 39:{
                            this.cursorPos=textField.selectionStart;
                            textField.setSelectionRange(this.cursorPos, this.cursorPos)
                            e.preventDefault();
                            break;
                        }
                
            }

            if(e.ctrlKey&& e.keyCode===86)
            {
                //console.log("copy paste");
                this.cursorPos=textField.selectionEnd;
                //console.log('cursor pos paste', this.cursorPos);
                this.$nextTick(() => {
                            textField.setSelectionRange(this.cursorPos, this.cursorPos)
                        })
            }
       },
       clearTextField(){
            this.textFieldValue='';
            this.cursorPos=0;
            var textField=this.$refs.textField.$refs.input;
            this.$nextTick(() => {
                        textField.setSelectionRange(this.cursorPos, this.cursorPos)
            })
            textField.focus();
        }
    
    },
    watch:{
            editedText(value)
                {
                    //console.log('watcher', value);
                    this.textFieldValue=value;
                     if(this.textFieldValue===undefined||this.textFieldValue===null)
                    {
                        this.textFieldValue='';
                        this.cursorPos=0;
                    }
                    var textField=this.$refs.textField.$refs.input;
                    textField.focus();
                    var len=this.textFieldValue.length;
                    //console.log('set caret pos len', len);
                    this.cursorPos=len;
                    this.$nextTick(() => {
                        textField.setSelectionRange(this.cursorPos, this.cursorPos)
                    })
                    //console.log('length', len, 'pos', textField.selectionStart);
                }
            }, 

    mounted(){
        //console.log('mounted');
        var textField=this.$refs.textField.$refs.input; 
        this.$nextTick(() => {
                textField.focus();
                this.cursorPos=this.editedText.length;
           })
    }
}
</script>
<style scoped>
.custom_form {
    margin: 10px 0 0;
    border-top: 3px solid #1b73ba;
}
.custom_form >>> .v-card {
    padding-top: 20px;
}
</style>